module.exports = __webpack_public_path__ + "img/nbwxfw.96d451ee.png";